import { DashboardSidebar } from './DashboardSidebar'
import { BaseDashboardLayout } from './BaseDashboardLayout'
import { AccessDeniedRedirectListener } from '@/components/guards/AccessDeniedRedirectListener'

export function DashboardLayout() {
  return (
    <>
      <AccessDeniedRedirectListener />
      <BaseDashboardLayout sidebar={<DashboardSidebar />} />
    </>
  )
}

